import { defineMessages } from 'react-intl';

export default defineMessages({
    title: {
        id: '_.modal.id_check_verification.title',
        defaultMessage: `Identity check`
    },
    subTitle: {
        id: '_.modal.id_check_verification.subTitle',
        defaultMessage: `We need to check your identity to make sure we’re sending money to the right person. We use {id_verification_provider_name} verification, which is a secure way to do this. You'll just need your passport or driving license, and your smartphone.`
    },
    subTitleMultiple: {
        id: '_.modal.id_check_verification.subTitleMultiple',
        defaultMessage: `We need to verify your identity, as well as the identities of all guarantors, to ensure the funds are sent securely to the correct person. {id_verification_provider_name} is the most secure way to do this.`
    },
    requirementsSubTitle: {
        id: '_.modal.id_check_verification.requirementsSubTitle',
        defaultMessage:
            'Select your mobile number and click to send yourself a text below. Once you receive the text, click on the link to complete your check.'
    },
    requirementsSubTitleMultiple: {
        id: '_.modal.id_check_verification.requirementsSubTitleMultiple',
        defaultMessage:
            'Select your mobile number below and click to send yourself a text, which will contain a link for you to complete the check. Do the same for everyone listed so they can complete theirs too (and maybe give them a heads up to speed things along!).'
    },
    resendMessage: {
        id: '_.modal.id_check_verification.resend_message',
        defaultMessage: `Re-send SMS`
    },
    sendText: {
        id: '_.modal.id_check_verification.send',
        defaultMessage: `Send SMS`
    },
    close: {
        id: '_.modal.id_check_verification.close',
        defaultMessage: 'Close'
    },
    cancel: {
        id: '_.modal.id_check_verification.cancel',
        defaultMessage: 'Cancel'
    },
    save: { id: '_.modal.id_check_verification.save', defaultMessage: 'Save' },
    enterValidNumber: {
        id: '_.modal.id_check_verification.error.enter_valid_number',
        defaultMessage: 'Please enter a valid mobile number'
    },
    yourPhoneNumber: {
        id: '_.modal.id_check_verification.your_phone_number',
        defaultMessage: 'Your mobile'
    },
    addNew: {
        id: '_.modal.id_check_verification.add_new',
        defaultMessage: 'Add new'
    },
    didNotReceiveText: {
        id: '_.modal.id_check_verification.did_not_receive_text',
        defaultMessage: "Didn't receive it?"
    },
    continueText: {
        id: '_.modal.id_check_verification.continue',
        defaultMessage: 'Continue'
    },
    letsTryThatAgain: {
        id: '_.modal.id_check_verification.lets_try_that_again',
        defaultMessage: "Let's try that again!"
    },
    makeSureAllTextsSentInfo: {
        id: '_.modal.id_check_verification.make_sure_all_texts_sent_info',
        defaultMessage:
            'Please give us a call on {phoneNumber} if you need help completing this step'
    },
    makeSureAllTextsSentInfoMultiple: {
        id: '_.modal.id_check_verification.make_sure_all_texts_sent_info_multiple_guarantors',
        defaultMessage:
            'Please ensure that everyone listed completed the check. Give us a call on {phoneNumber} if you need help completing this step.'
    },
    somethingWentWrongInfo: {
        id: '_.modal.id_check_verification.something_went_wrong_info',
        defaultMessage:
            "Something's gone wrong! Please try again and make sure everyone listed has completed the check."
    },
    notStartedYet: {
        id: '_.modal.id_check_verification.not_started_yet',
        defaultMessage: 'Not started yet'
    },
    verified: {
        id: '_.modal.id_check_verification.verified',
        defaultMessage: 'Verified'
    },
    somethingWentWrong: {
        id: '_.modal.id_check_verification.something_went_wrong',
        defaultMessage:
            'Something went wrong - please send another SMS and try again'
    },
    verifyingYourCheck: {
        id: '_.modal.id_check_verification.verifying_check',
        defaultMessage: 'Verifying your check'
    },
    verifyingNameCheck: {
        id: '_.modal.id_check_verification.verifying_name_check',
        defaultMessage: 'Verifying {values} check'
    },
    smsFailed: {
        id: '_.modal.id_check_verification.sms_failed',
        defaultMessage:
            "Your SMS didn't go through. Please try it again by clicking 'Send SMS'."
    },
    reachedMaxOnfidoChecks: {
        id: '_.modal.id_check_verification.reached_max_onfido_checks',
        defaultMessage:
            'Please give your account manager a call on {phoneNumber} to continue.'
    },
    phoneNumber: {
        id: '_.modal.id_check_verification.phone_number',
        defaultMessage: '020 3778 0105'
    }
});
